<template>
    <div>
        <span @click.stop="getItem">
            <font-awesome-icon icon="pencil-alt" class="align-middle cursor-pointer"/>
        </span>
        <c-modal
            v-model="modal"
            cancel-label="Cancel"
            centered
            title="Edit Item Availability Control"
            :tag="false"
            confirm-label="Update Control"
            :progressing="loading"
            size="lg"
        >
            <template>
                <b-container class="p-0">
                    <b-row>
                        <b-col cols="12">
                            <b-form-group class="text-center" label="">
                                <b-form-radio-group disabled @change="changeItemType" class="" size="lg" id="radio-group-2" v-model="ItemType" name="radio-sub-component">
                                    <b-form-radio class="mx-5" size="lg" value="Food">Food</b-form-radio>
                                    <b-form-radio class="mx-5" size="lg" value="Drink">Drink</b-form-radio>
                                </b-form-radio-group>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <div class="overflow-auto">
                                <b-button-group disabled class="groupsButtons" size="sm">
                                    <b-button
                                            style="font-size: 0.9rem"
                                            v-for="item in MenuTypeAl"
                                            class="py-4 px-3"
                                            @click="GetRestaurantItems(item, item.MenuTypeID, ItemType)"
                                            :class="item.selected ? 'activeBtn' : 'deactiveBtn'"
                                            disabled
                                    >
                                        {{item.MenuType}}
                                    </b-button>
                                </b-button-group>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <div class="my-3 multiselect-availability">
                                <Multiselect
                                        disabled
                                        class="miniMulti"
                                        v-model="ItemCategory"
                                        :options="RestaurantItems"
                                        v-validate="'required'"
                                        name="item"
                                        placeholder="انتخاب کنید"
                                />
                            </div>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-input-group prepend="Quantity Limit" class="my-3">
                                <b-input type="number" @keypress="preventTypeString" v-model="QuantityLimit" v-validate="'required|min_value:1'" name="Quantity Limit"/>
                            </b-input-group>
                            <b-input-group prepend="Remaining Count" class="my-3">
                                <b-input type="text" @keypress="preventTypeString" v-model="Total_Remain" v-validate="`required|max_value: ${QuantityLimit}`" name="Remaining Count"/>
                            </b-input-group>
                        </b-col>
                        <b-col cols="12" md="6" class="align-self-center">
                            <div style="background: #ffeaf1" class="p-2">
                                <div>
                                    <b-form-checkbox
                                            id="checkbox-1"
                                            v-model="reset"
                                            name="checkbox-1"
                                            :value="true"
                                            :unchecked-value="false"
                                    >
                                    End of Day Quantity Limit Reset
                                    </b-form-checkbox>
                                </div>
                                <div class="mt-3 ml-4" v-if="reset">
                                    <b-form-group name="ResetAction" v-slot="{ ariaDescribedby }">
                                        <b-form-radio class="mb-3" v-model="ResetAction" :aria-describedby="ariaDescribedby" name="ResetAction" value="r">Quantity Limit</b-form-radio>
                                        <b-form-radio v-model="ResetAction" :aria-describedby="ariaDescribedby" name="ResetAction" value="d">Unlimited (Suspend this control permanently)</b-form-radio>
                                    </b-form-group>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <b-alert :show="errors.any()" variant="danger" class="px-4 my-2">
                                <ul class="m-0 px-1">
                                    <li v-for="err in errors.all()" :key="err">{{err}}</li>
                                </ul>
                            </b-alert>
                        </b-col>
                    </b-row>
                </b-container>
            </template>
            <template #actions>
                <b-row class="flex-grow-1">
                    <b-col cols="4">
                        <b-btn variant="warning" block class="text-nowrap" :disabled="loadingBtn" @click="updateItem">
                            Update Control
                            <font-awesome-icon v-if="loadingBtn" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                        </b-btn>
                    </b-col>

                    <b-col cols="4">
                        <b-btn variant="danger" block class="text-nowrap" :disabled="loadingBtn" @click="deleteItem">
                            Delete Control
                            <font-awesome-icon v-if="loadingBtn" spin icon="circle-notch" class="text-black align-middle mx-1"/>
                        </b-btn>
                    </b-col>

                    <b-col cols="4">
                        <b-btn variant="danger" block class="text-nowrap cancel-btn-cmodal" @click="modal = false">
                            Cancel
                        </b-btn>
                    </b-col>
                </b-row>
            </template>
        </c-modal>
    </div>
</template>

<script>
    import Multiselect from '../../shared/multiselect'
    import NumericInput from "../../shared/NumericInput";
    import CModal from "../../shared/Cmodal";
    export default {
        name: "addAvailable",
        components: {
            CModal,
            Multiselect,
            NumericInput
        },
        props: {
            value: {required: true},
            itemType: {required: true}
        },
        data () {
            return {
                loadingBtn: false,
                modal: false,
                confirmationDeleteModal: false,
                ItemType: 'Food',
                RestaurantItems: [],
                QuantityLimit: null,
                DrinkID: null,
                FoodId: null,
                ItemCategory: null,
                SelectedMenuType: null,
                status: false,
                reset: false,
                ResetAction: 'r',
                MenuTypeID: null,
                MenuTypeAl: [],
                Total_Remain: null
            }
        },
        mounted () {

            // this.GetRestaurantMenuTypes(this.ItemType)
        },
        methods: {
            preventTypeString (evt) {
                if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57){
                    evt.preventDefault();
                }
            },
            getItem () {
                const model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    ItemType: this.itemType,
                    ItemID: this.value.ItemID
                }
                this.ItemType = this.itemType
                this.$api.getRestaurant.GetItemAvailability(model).then(res => {
                    if (res.success) {
                        let results = res.results
                        if (results.ResetAction) {
                            this.reset = true
                            this.ResetAction = results.ResetAction.toLowerCase()
                        } else {
                            this.ResetAction = 'r'
                        }
                        this.QuantityLimit = results.Total
                        this.Total_Remain = results.Total_Remain
                        this.modal = true
                        this.GetRestaurantMenuTypes(this.itemType)
                    } else {
                        this.$showError(res.message)
                    }
                }).catch(() => {})
            },
            changeItemType (value) {
                //filter menu types by two value - drink or food

                this.GetRestaurantMenuTypes(value)
            },
            GetRestaurantMenuTypes (ItemType) {
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    ItemType
                }
                this.$api.getRestaurant.GetRestaurantMenuTypes(model).then(res => {
                    if (res.success) {
                        this.RestaurantItems = []
                        this.MenuTypeAl = res.results.RestaurantMenuTypeAll.filter(item => item.CanMenuTypeBeShown)
                        this.MenuTypeAl.forEach(item => {
                            this.$set(item, 'selected', false)
                            if (item.MenuTypeID === this.value.MenuTypeID) {
                                item.selected = true
                                this.MenuTypeID = item.MenuTypeID
                                this.GetRestaurantItems(this.MenuTypeID, this.itemType)
                            }
                        })
                    } else {
                        this.$showError(res.message)
                    }
                })
            },
            GetRestaurantItems (MenuTypeID, ItemType) {
                //get restaurant items by selected menutype and item type
                let model = {
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    // UserID: localStorage.getItem('userID'),
                    ItemType,
                    MenuTypeID
                }
                this.$api.getRestaurant.GetRestaurantItems(model).then(res => {
                    if (res.success) {
                        this.ItemCategory = null
                        this.PriceType = null
                        let result =  res.results.RestaurantItems
                        result.forEach(item => {
                            if (this.value.ItemName === item.ItemName) {
                                this.ItemCategory = item
                            }
                            item.value = item.ItemID
                            item.availablePrices = [
                                {text: 'Price', value: item.Price},
                                {text: 'Price1', value: item.Price1},
                                {text: 'Price2', value: item.Price2},
                                {text: 'Price3', value: item.Price3},
                                {text: 'Price4', value: item.Price4},
                            ]
                            if (item.availablePrices.filter(i => i.value > 0).length > 1) {
                                item.priceSymbol = ' + '
                            } else {
                                item.priceSymbol = ''
                            }
                            if (item.HasModifier) {
                                item.priceSymbol = ' + '
                            }
                            if (item.Price !== -999999) {
                                item.name = item.ItemCategory + ' - ' + item.ItemName + ' - ' + '$' + item.Price + item.priceSymbol + (item.IsAvailable ? '' : ' (Not available till further notice)')
                            } else {
                                item.name = item.ItemCategory + ' - ' + item.ItemName + ' ' + item.priceSymbol + (item.IsAvailable ? '' : ' (Not available till further notice)')
                            }

                        })
                        this.RestaurantItems = result

                    } else {
                        this.$showError(res.message)
                    }
                })
            },
            updateItem () {
                this.$validator.validateAll().then(res => {
                    if (res) {
                        const object = {
                            // UserID: localStorage.getItem('userID'),
                            RestaurantID: this.$store.state.selectedRestaurantId,
                            ItemID: this.ItemCategory.ItemID,
                            ItemType: this.ItemType,
                            Breakdown: 0,
                            Total: this.QuantityLimit,
                            Pickup: '',
                            Delivery: '',
                            Dinein: '',
                            ResetAction: this.reset ? this.ResetAction : '',
                            Total_Remain: this.Total_Remain
                        }
                        this.loadingBtn = true
                        this.$api.getRestaurant.UpdateItemAvailability(object).then(res => {
                            this.loadingBtn = false
                            if (res.success) {
                                this.modal = false
                                this.resetData()
                                this.$emit('refreshGetAll', this.$store.state.selectedRestaurantId)
                            } else {
                                this.$showError(res.message)
                            }
                        }).catch(() => {
                            this.loadingBtn = false
                        })
                    }
                })
            },
            deleteItem () {
                this.$showConfirm(undefined, 'Do you want to delete this item availability control?').then(() => {
                    const model = {
                        // UserID: localStorage.getItem('userID'),
                        RestaurantID: this.$store.state.selectedRestaurantId,
                        ItemID: this.ItemCategory.ItemID,
                        ItemType: this.itemType,
                    }
                    this.loadingBtn = true
                    this.$api.getRestaurant.DeleteItemAvailability(model).then(res => {
                        this.loadingBtn = false
                        if (res.success) {
                            this.modal = false
                            this.$emit('refreshGetAll', this.$store.state.selectedRestaurantId)
                        } else {
                            this.$showError(res.message)
                        }
                    }).catch(err => {
                        this.loadingBtn = false
                        this.$showError(err)
                    })
                })
            },
            resetData () {
                this.modal = false
            }
        }
    }
</script>

<style scoped lang="scss">
    .activeBtn {
        background: #f5c31d !important;
        border-color: #464b50 !important;
    }
    .deactiveBtn {
        background: #fff !important;
        border-color: #464b50 !important;
        color: #464b50 !important;
    }
    select{
        option{
            span#itemName{
                font-weight: bold !important;
                color: red !important;
            }
        }
    }
</style>
